import React from 'react';
import './contact.scss'
import DetailContact from '../../Molecules/Detail-Contact';
const Contact = () => {
    return (
        <div className="contact-organisms" id="contact">
            <div className="container">
                <div className="heading-section text-center">
                    <h2 className="text-uppercase">Contact</h2>
                </div>
                <DetailContact/>
            </div>
        </div>
    );
};

export default Contact;